import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { GatekeeperProvider } from "./components/Gatekeeper";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatAgent from "./components/ChatAgent";
import VisualEffects from "./components/VisualEffects";

// Pages
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import UseCasesPage from "./pages/UseCasesPage";
import DocsPage from "./pages/DocsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import InvestorsPage from "./pages/InvestorsPage";
import MarketplacePage from "./pages/MarketplacePage";
import WhitepapersPage from "./pages/WhitepapersPage";
import GovernancePage from "./pages/GovernancePage";
import NotFoundPage from "./pages/NotFoundPage";
import X402Page from "./pages/X402Page";
import DocsX402Page from "./pages/DocsX402Page";

import "./App.css";

function App() {
  // Hide Emergent badge on mount
  React.useEffect(() => {
    const hideEmergentBadge = () => {
      const selectors = [
        'a[href*="emergent"]',
        'div[class*="emergent"]',
        '[data-emergent]',
        'div[style*="z-index: 2147483647"]'
      ];
      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          if (!el.closest('[data-testid]') || el.matches('a[href*="emergent"]')) {
            el.style.display = 'none';
          }
        });
      });
    };
    
    hideEmergentBadge();
    const interval = setInterval(hideEmergentBadge, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <GatekeeperProvider>
          <VisualEffects>
            <div className="App min-h-screen bg-swarm-bg relative" style={{ zIndex: 2 }}>
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/product" element={<ProductPage />} />
                  <Route path="/use-cases" element={<UseCasesPage />} />
                  <Route path="/marketplace" element={<MarketplacePage />} />
                  <Route path="/pricing" element={<Navigate to="/contact" replace />} />
                  <Route path="/docs" element={<DocsPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/investors" element={<InvestorsPage />} />
                  <Route path="/whitepapers" element={<WhitepapersPage />} />
                  <Route path="/governance" element={<GovernancePage />} />
                  <Route path="/x402" element={<X402Page />} />
                  <Route path="/docs/x402" element={<DocsX402Page />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
              <Footer />
              <ChatAgent />
              <Toaster 
                position="bottom-right" 
                toastOptions={{
                  style: {
                    background: '#1E293B',
                    border: '1px solid rgba(148, 163, 184, 0.1)',
                    color: '#F8FAFC',
                  },
                }}
              />
            </div>
          </VisualEffects>
        </GatekeeperProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
